module.exports = __webpack_public_path__ + "static/media/aicte.5632cb3d.png";